export const BANNER_DISMISS_KEY = 'meowmi_share_banner_dismissed'

const STATES = {
  'artwork:available': {
    icon: '✨',
    title: '你的朋友想聽聽你對這張的看法',
    subtitle: '隨意欣賞，喜歡的話再決定',
    ctaText: '我想要這張 →',
    ctaHref: '#cta',
  },
  'artwork:claimed': {
    icon: '🐾',
    title: '這張已經有主人了',
    subtitle: '不過還有好多可愛的等你看',
    ctaText: '看看類似款式 →',
    ctaHref: '#related',
  },
  'sticker:any': {
    icon: '🎀',
    title: '你的朋友挑了這張',
    subtitle: '要一起湊一組嗎？',
    ctaText: '加進我的貼紙組合 →',
    ctaHref: '#cta',
  },
}

/**
 * 依 kind + status 決定 banner 內容
 * @param {{ kind?: string, status?: string }} params
 * @returns {{ icon: string, title: string, subtitle: string, ctaText: string, ctaHref: string } | null}
 */
export function getBannerState({ kind, status } = {}) {
  if (kind === 'sticker') return STATES['sticker:any']
  if (kind === 'artwork') {
    const effectiveStatus = status === 'claimed' ? 'claimed' : 'available'
    return STATES[`artwork:${effectiveStatus}`]
  }
  return null
}

/**
 * 判斷是否該顯示 banner（看 ?ref & sessionStorage dismissed flag）
 * @param {{ refParam: string | null | undefined, storage: Storage | null }} params
 * @returns {boolean}
 */
export function shouldShowBanner({ refParam, storage } = {}) {
  if (refParam !== 'share') return false
  if (!storage) return true
  return storage.getItem(BANNER_DISMISS_KEY) !== '1'
}

/**
 * dismiss 操作 — 將 dismissed flag 寫入 storage
 * @param {Storage | null | undefined} storage
 */
export function markBannerDismissed(storage) {
  if (!storage) return
  try {
    storage.setItem(BANNER_DISMISS_KEY, '1')
  } catch {
    // storage 可能因 Safari private mode 拒絕，安靜失敗
  }
}
